export var ITEMS_COUNTER = 'items-counter';
//# sourceMappingURL=constants.js.map